import React, { createContext, useState } from 'react'

import LocalStorage from 'utils/myLocalStorage'
import ComponentsUNames from 'constants/componentsUNames'
import { useTranslation } from 'react-i18next'

import { setDefaultOptions } from 'date-fns'

import { fr } from 'date-fns/locale'

const langDefault = 'fr'

export type Lang = 'fr' | 'en'

type LangContext = {
  lang: Lang
  handleSwitchLanguage: (l: Lang) => void
}

const LangContext = createContext<LangContext>({ lang: 'fr', handleSwitchLanguage: () => {} })

export const LangProvider = ({ children }) => {
  const { i18n } = useTranslation()

  const [lang, setLang] = useState(
    LocalStorage.getOrDefault(
      [LocalStorage.KEY_PREFS, ComponentsUNames.USERPREFS_STORE_NAME, ComponentsUNames.USERPREFS_LANG],
      LocalStorage.VALUE_TYPE.STRING,
      langDefault,
    ),
  )

  const handleSwitchLanguage = (lg: 'fr' | 'en') => {
    const langToUse = ['fr', 'en'].includes(lg.toLowerCase()) ? lg.toLowerCase() : langDefault
    // Store in LocalStorage (user-prefs)
    LocalStorage.put(
      [LocalStorage.KEY_PREFS, ComponentsUNames.USERPREFS_STORE_NAME, ComponentsUNames.USERPREFS_LANG],
      langToUse,
    )

    setLang(langToUse)
    i18n.changeLanguage(langToUse)
    // for now only french is used for date parsing and formatting
    setDefaultOptions({ locale: fr })
  }

  return <LangContext.Provider value={{ lang, handleSwitchLanguage }}>{children}</LangContext.Provider>
}

export default LangContext
